(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbb-gallery-sale-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  // Empire's variant-change event does not bubble; capture it at the document.
  document.addEventListener('variant-change', (event) => {
    const productContainer = event.target.closest('.product--outer');
    if (!productContainer || !event.detail) return;
    const badge = productContainer.querySelector('[data-gallery-sale-badge]');
    if (!badge) return;
    const { variant, product, state } = event.detail;
    const discounted = (item) => Boolean(item && item.available &&
      Number(item.compare_at_price) > Number(item.price));
    const onSale = variant ? discounted(variant) :
      state !== 'unavailable' && Boolean(product && product.variants.some(discounted));
    badge.hidden = !onSale;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
